module.exports = __webpack_public_path__ + "media/images/ico-play@2x-fdd5a756e1bde5ab47d57d36cbc537cd.png";